module.exports = __webpack_public_path__ + "assets/img/order_3.5a61a1bd.svg";